export default __webpack_public_path__ + "static/assets/034c274c8ab97fdb3975d310c571a72a.png";